"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'YsFixedBottomActions',
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    handleClear() {
      this.$emit('update:data', []);
      this.$emit('clear');
    }
  }
};